import { __styles, mergeClasses, shorthands } from '@griffel/react';
/**
 * Static CSS class names used internally for the component slots.
 */
export const cardFooterClassNames = {
  root: 'fui-CardFooter',
  action: 'fui-CardFooter__action'
};
const useStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1063pyq",
    i8kkvl: "f4akndk",
    Belr9w4: "fe5j3v"
  },
  action: {
    Frg6f3: ["fcgxt0o", "f1ujusj6"]
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1063pyq{flex-direction:row;}", ".f4akndk{column-gap:12px;}", ".fe5j3v{row-gap:12px;}", ".fcgxt0o{margin-left:auto;}", ".f1ujusj6{margin-right:auto;}"]
});
/**
 * Apply styling to the CardFooter slots based on the state.
 */
export const useCardFooterStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(cardFooterClassNames.root, styles.root, state.root.className);
  if (state.action) {
    state.action.className = mergeClasses(cardFooterClassNames.action, styles.action, state.action.className);
  }
  return state;
};
//# sourceMappingURL=useCardFooterStyles.styles.js.map